import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69267ae7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center text-start" }
const _hoisted_2 = {
  href: "#",
  class: "fs-6 text-gray-800 text-hover-primary fw-bold"
}
const _hoisted_3 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_4 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}

import { computed, inject, ref } from "vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import { CommentType } from "@/core/types/CommentType";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { TagNames } from "@/core/types/TagTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  props: {
    side: {},
    rounded: { type: Boolean, default: false },
    size: {},
    isAdmin: { type: Boolean },
    user: {},
    partyId: {},
    name: {},
    email: {},
    disableCommentView: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;


const commentsRef = ref<any>(null);

const displayName = computed(
  () =>
    props?.name ||
    props.user?.nativeName ||
    props.user?.displayName ||
    `${props.user?.firstName} ${props.user?.lastName}`
);
const openUserDetailSider = inject<(partyId: number) => any>(
  InjectKeys.OPEN_USER_DETAILS,
  () => null
);

const onUserClicked = () => {
  if (props.user?.partyId) {
    openUserDetailSider?.(props.user.partyId);
  } else if (props.partyId) {
    openUserDetailSider?.(props.partyId);
  }
};

const openCommentView = inject<
  (type: CommentType, id: number, title: string) => any
>(InjectKeys.OPEN_COMMENT_VIEW, () => null);

const onCommentClicked = (type: CommentType, id: number, title: string) => {
  if (props.user?.partyId) {
    openCommentView?.(type, id, title);
  }
};
const handleGodModeClick = UserService.generateGodModeHandler();

// const viewComments = (type: CommentType, id: number, title: string) => {
//   commentsRef.value?.show(type, id, title);
// };

/*
{
  "firstName": "string",
  "lastName": "string",
  "priorName": "string",
  "birthdate": "string",
  "gender": "string",
  "citizen": "string",
  "ccc": "string",
  "phone": "string",
  "email": "string",
  "address": "string",
  "idFrom": "string",
  "idNumber": "string",
  "idOffice": "string",
  "idIssueDate": "string",
  "idExpiryDate": "string"
}


{
  "nativeName": "string",
  "firstName": "string",
  "lastName": "string",
  "language": "string",
  "timeZone": "string",
  "referCode": "string",
  "countryCode": "string",
  "currency": "string",
  "ccc": "string",
  "birthday": "2023-08-03",
  "gender": 0,
  "citizen": "string",
  "address": "string",
  "idType": 0,
  "idNumber": "string",
  "idIssuer": "string",
  "idIssuedOn": "2023-08-03",
  "idExpireOn": "2023-08-03"
}
 */

return (_ctx: any,_cache: any) => {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserAvatar, {
      onClick: onUserClicked,
      avatar: props.user?.avatar,
      name: displayName.value,
      class: "me-3 cursor-pointer",
      side: props.side,
      rounded: props.rounded,
      size: props.size
    }, null, 8, ["avatar", "name", "side", "rounded", "size"]),
    _createElementVNode("div", null, [
      _createElementVNode("a", _hoisted_2, [
        _createElementVNode("span", {
          onClick: onUserClicked,
          class: _normalizeClass(
            props.user?.partyTags?.includes(_unref(TagNames).Special)
              ? 'special-tag'
              : ''
          )
        }, _toDisplayString(displayName.value), 3),
        (!_ctx.disableCommentView && _ctx.$can('Admin'))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "ms-4 cursor-pointer",
              role: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
            onCommentClicked(
              _unref(CommentType).User,
              props.user?.partyId,
              props.user?.firstName + ' ' + props.user?.lastName
            )
          ))
            }, [
              (props.user?.hasComment)
                ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                : (_openBlock(), _createElementBlock("i", _hoisted_4))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "fs-7 text-muted fw-semobold mt-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleGodModeClick)(props.user.partyId)))
      }, [
        _createTextVNode(_toDisplayString(props.user?.email || props?.email || "") + " ", 1),
        (props.isAdmin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(Admin)"))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.disableCommentView && _ctx.$can('TenantAdmin'))
      ? (_openBlock(), _createBlock(CommentsView, {
          key: 0,
          ref_key: "commentsRef",
          ref: commentsRef,
          type: "",
          id: "0"
        }, null, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})